import { cmsPropertyId } from './cmsConfig';
const isEnabled = (property) => property.isEnabled !== false;
const toRef = (property) => ({
    id: cmsPropertyId(property),
    name: property.name
});
// The dropdown value encodes the scope so an ambiguous label (a city that
// shares a name with a region) still resolves to the right search mode.
const optionValue = (type, id) => `${type}:${id}`;
const propertyOptions = (config) => config.properties.filter(isEnabled).map(property => ({
    value: optionValue('property', cmsPropertyId(property)),
    type: 'property',
    id: cmsPropertyId(property),
    label: property.name
}));
const cityOptions = (config) => config.locations.map(city => ({
    value: optionValue('city', city),
    type: 'city',
    id: city,
    label: city
}));
const regionOptions = (config) => config.regions.map(region => ({
    value: optionValue('region', region),
    type: 'region',
    id: region,
    label: region
}));
export const buildSearchOptions = (config) => [
    ...propertyOptions(config),
    ...cityOptions(config),
    ...regionOptions(config)
];
// Parses a dropdown value back into a selection. Returns undefined for the
// empty/placeholder value so the caller can treat it as "nothing chosen".
export const parseSelection = (value, options) => {
    const option = options.find(o => o.value === value);
    if (!option) {
        return undefined;
    }
    return { type: option.type, id: option.id, label: option.label };
};
export const resolvePropertiesForSelection = (config, selection) => {
    const enabled = config.properties.filter(isEnabled);
    switch (selection.type) {
        case 'property': {
            const match = enabled.find(p => cmsPropertyId(p) === selection.id);
            return match ? [toRef(match)] : [];
        }
        case 'city':
            return enabled.filter(p => p.location === selection.id).map(toRef);
        case 'region':
            return enabled
                .filter(p => (p.regions ?? []).includes(selection.id))
                .map(toRef);
    }
};
